module.exports = __webpack_public_path__ + "img/9AA8B6_313133_4E5055_D7EBF8-256px.58f88524.png";